import { httpClient } from '@pascal/pascal-core';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';

import { getBalanceUrl } from '../../core/constants/endpoints';

class PlayerService {

  __timeout = null;

  /**
   * @name getBalance
   * @returns {Promise<number>}
   */
  async getBalance() {
    return await httpClient.get(getBalanceUrl());
  }

  /**
   * @name updateBalance
   * @returns {void}
   */
  updateBalance() {
    clearTimeout(this.__timeout);
    this.__timeout = setTimeout(() => {
      this.getBalance().then(data => {
        userInfoStore.setBalance(data.data.result.balance);
      });
    }, 1000);
  }

  /**
   * @name updateDemoBalance
   * @param {number} balance
   * @returns {void}
   */
  updateDemoBalance(balance) {
    const validBalance = Math.floor(balance * 1000) / 1000;
    userInfoStore.setDemoBalance(validBalance);
  }
}

export const playerService = new PlayerService();
